export default function GetStarted() {
  return <h3>Coming soon</h3>;
}
